import { POPUP_COMPONENT } from "../constants/ActionTypes";

/**
 *
 * @POPUP_STATE: 0:off 1: on
 * @POPUP_MODULE: module_name
 * @POPUP_PARAMETERS: parameters
 * @POPUP_CALLBACK_KEY: callback(key)
 * @POPUP_CALLBACK_VALUE: callback(value)
 */
const initialPopupState = {
    POPUP_STATE: 0,
    POPUP_MODULE: null,
    POPUP_PARAMETERS: null,
    POPUP_CALLBACK_KEY: null,
    POPUP_CALLBACK_VALUE: null,

    POPUP_PUBLIC_STEP : 0,
    POPUP_PUBLIC_KEY : null,
    POPUP_PUBLIC_CALLBACK : null,
};

export default function ( state = initialPopupState, action = {} ){
    let POPUP_STATE = action.POPUP_STATE;
    let POPUP_MODULE = action.POPUP_MODULE;
    let POPUP_PARAMETERS = action.POPUP_PARAMETERS;
    let POPUP_CALLBACK_KEY = action.POPUP_CALLBACK_KEY;
    let POPUP_CALLBACK_VALUE = action.POPUP_CALLBACK_VALUE;

    let POPUP_PUBLIC_STEP = action.POPUP_PUBLIC_STEP;
    let POPUP_PUBLIC_KEY = action.POPUP_PUBLIC_KEY;
    let POPUP_PUBLIC_CALLBACK = action.POPUP_PUBLIC_CALLBACK;

    switch( action.type ){

        case POPUP_COMPONENT.POPUP_STATE:
            return Object.assign({},state,{
                POPUP_STATE,
                POPUP_MODULE,
                POPUP_PARAMETERS,
                POPUP_CALLBACK_KEY,
                POPUP_CALLBACK_VALUE
            });

        /*公共的弹层*/
        case POPUP_COMPONENT.POPUP_PUBLIC_STEP:
            return Object.assign({},state,{
                POPUP_PUBLIC_STEP,
                POPUP_PUBLIC_KEY,
                POPUP_PUBLIC_CALLBACK
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/popup_component.js